module.exports = __webpack_public_path__ + "img/headportrait_6_icon.1849ccf4.png";